import axios from "@/api/axios";

const get_shotstats = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    shotstats: [],
  };

  const options = {
    method: "GET",
    url: "/manager/shotstats",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      clubtype: param.clubtype,
      pageno: param.pageno,
      pagesize: param.pagesize,
      orderby: param.orderby, // 추가
      order: param.order, // 추가
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_shotstats", err);
    result(false, err);
  }
};

const get_coursestats = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    coursestats: [],
  };

  const options = {
    method: "GET",
    url: "/manager/coursestats",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      pagesize: param.pagesize,
      orderby: param.orderby,
      order: param.order,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_coursestats", err);
    result(false, err);
  }
};

const get_memberstats = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    memberstats: [],
  };

  const options = {
    method: "GET",
    url: "/manager/memberstats",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      pagesize: param.pagesize,
      orderby: param.orderby, // 추가
      order: param.order, // 추가
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_memberstats", err);
    result(false, err);
  }
};

const get_venuestats = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    venuestats: [],
  };

  const options = {
    method: "GET",
    url: "/manager/venuestats",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      pagesize: param.pagesize,
      orderby: param.orderby,
      order: param.order,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_venuestats", err);
    result(false, err);
  }
};

const get_playtimestats = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    diffdays: 1,
    playtimestats: [],
  };

  const options = {
    method: "GET",
    url: "/manager/playtimestats",
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
      pagesize: param.pagesize,
      orderby: param.orderby, // 추가
      order: param.order, // 추가
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playtimestats", err);
    result(false, err);
  }
};

export default {
  get_shotstats,
  get_coursestats,
  get_memberstats,
  get_venuestats,
  get_playtimestats,
};
